import { render } from "./addStudent.vue?vue&type=template&id=6d8895a0"
import script from "./addStudent.vue?vue&type=script&lang=js"
export * from "./addStudent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\self\\loyi\\pro-DT-member-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__